import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  @Input() expanded: boolean = false;

  constructor(private readonly router: Router) {}

  goHome(): void {
    this.router.navigate(['/home']);
  }
}
